import { Quote } from 'lucide-react';

export function FortyYearProblem() {
  return (
    <section className="py-20 md:py-28 bg-secondary">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-xs font-semibold tracking-widest uppercase text-muted-foreground mb-4">
              The Origin
            </p>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6">
              Decades of Observation, One Essential Solution.
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed max-w-2xl mx-auto">
              Dr. Larkin spent four decades witnessing the "Gray Zone" — the gap
              between the complexity of a surgery and the administrative failure of
              the billing cycle. He saw surgeons burdened by paperwork and
              hospitals losing millions in earned revenue due to technicalities.
              LINK was born from the necessity of clinical truth.
            </p>
          </div>

          <div className="max-w-3xl mx-auto mt-12 md:mt-16">
            <div className="rounded-xl border border-border bg-card p-8 md:p-10">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 border border-primary/20 mb-6">
                <Quote className="h-5 w-5 text-primary" strokeWidth={1.5} />
              </div>
              <blockquote className="text-lg md:text-xl text-foreground leading-relaxed font-medium italic">
                "I didn't build LINK to be another software tool. I built it to
                ensure that when a surgeon performs a complex procedure, the
                hospital's financial record actually reflects the clinical
                reality."
              </blockquote>
              <div className="mt-6 flex items-center gap-3">
                <div className="h-px flex-1 bg-border" />
                <div className="text-right">
                  <p className="text-sm font-bold text-foreground">Dr. John J. Larkin, M.D.</p>
                  <p className="text-xs text-muted-foreground">Founder, LINK Medical</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
